import {
    CreateSlotRequest,
    CreateSlotResponse,
    DeleteSlotRequest,
    DeleteSlotResponse,
    GetSlotPageRequest,
    GetSlotPageResponse,
    GetSlotRequest,
    GetSlotResponse,
    UpdateSlotRequest,
    UpdateSlotResponse
} from "../../models/slot"
import { queryApi } from "../api"
import { SLOT_API_ERROR_MESSAGES } from "../constants/slots.const"
import { slotsTag } from "../tags"
import { onQueryStartedErrorHandler } from "../utility/error"

const invalidateTagsFn = (_: unknown, __: unknown, { projectId }: { projectId: string }) => [
    { type: slotsTag, projectId }
]

export const slotsApiController = queryApi.injectEndpoints({
    endpoints: build => {
        return {
            getSlotById: build.query<GetSlotResponse, GetSlotRequest>({
                query: ({ projectId, slotId }) => ({
                    url: `${projectId}/slot/${slotId}`,
                    method: "GET"
                })
            }),
            getSlotPage: build.query<GetSlotPageResponse, GetSlotPageRequest>({
                query: ({ projectId, body = { PageFrom: 0, PageSize: 1000 } }) => ({
                    url: `${projectId}/slot/page`,
                    method: "POST",
                    body
                }),
                onQueryStarted: onQueryStartedErrorHandler(SLOT_API_ERROR_MESSAGES.GET),
                providesTags(_, __, { projectId }) {
                    return [{ type: slotsTag, projectId }]
                }
            }),
            createSlot: build.mutation<CreateSlotResponse, CreateSlotRequest>({
                query: ({ projectId, body }) => ({
                    url: `${projectId}/slot`,
                    method: "POST",
                    body
                }),
                onQueryStarted: onQueryStartedErrorHandler(SLOT_API_ERROR_MESSAGES.CREATE),
                invalidatesTags: invalidateTagsFn
            }),
            updateSlot: build.mutation<UpdateSlotResponse, UpdateSlotRequest>({
                query: ({ projectId, slotId, body }) => ({
                    url: `${projectId}/slot/${slotId}`,
                    method: "PUT",
                    body
                }),
                onQueryStarted: onQueryStartedErrorHandler(SLOT_API_ERROR_MESSAGES.UPDATE),
                invalidatesTags: invalidateTagsFn
            }),
            deleteSlot: build.mutation<DeleteSlotResponse, DeleteSlotRequest>({
                query: ({ projectId, slotId }) => ({
                    url: `${projectId}/slot/${slotId}`,
                    method: "DELETE"
                }),
                onQueryStarted: onQueryStartedErrorHandler(SLOT_API_ERROR_MESSAGES.DELETE),
                invalidatesTags: invalidateTagsFn
            })
        }
    }
})

export const { useGetSlotPageQuery, useCreateSlotMutation, useUpdateSlotMutation, useDeleteSlotMutation } =
    slotsApiController
